import * as React from "react"
import { SvgComponentProps } from "../types/SVGPropType"
const GlobalArrowSVG: React.FC<SvgComponentProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ? props.width : 17}
    height={props.height ? props.height : 17}
    fill="none"
    viewBox="0 0 17 17"
    className={props.className}
    {...props}
  >
    <path
      fill="#A1A1A1"
      fillRule="evenodd"
      d="M13.332 6.596a12.02 12.02 0 0 1-.425 2.603 3.753 3.753 0 0 0 1.79-2.603h-1.365Zm-1.898 3.1a3.788 3.788 0 0 1-.871 0 10.766 10.766 0 0 1-.647-3.1h2.164a10.764 10.764 0 0 1-.646 3.1Zm1.898-4.35a12.02 12.02 0 0 0-.425-2.604 3.753 3.753 0 0 1 1.79 2.604h-1.365Zm-1.252 0a10.764 10.764 0 0 0-.646-3.1 3.788 3.788 0 0 0-.871 0 10.766 10.766 0 0 0-.647 3.1h2.164Zm-3.416 0c.046-.877.188-1.75.426-2.604A3.753 3.753 0 0 0 7.3 5.346h1.364Zm.426 3.853a12.015 12.015 0 0 1-.426-2.603H7.3a3.753 3.753 0 0 0 1.79 2.603Zm1.908 1.772a5 5 0 1 0 0-10 5 5 0 0 0 0 10Zm-8.75-.5h-.75v1.5h2.44l-3.22 3.22-.53.53 1.06 1.06.53-.53 3.22-3.22v2.44h1.5v-4a1 1 0 0 0-1-1h-3.25Z"
      clipRule="evenodd"
    />
  </svg>
)
export default GlobalArrowSVG
